import { Injectable } from '@angular/core';
import { CanActivate, Router, ActivatedRouteSnapshot, RouterStateSnapshot, CanActivateChild } from '@angular/router';
import { SecurityHelper } from '../pages/common/securityHelper';
import swal from 'sweetalert2';
import { NavigationItem } from '../theme/layout/admin/navigation/navigation';
import { SecurityService } from '../pages/security/service/security.service';
import { firstValueFrom } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class AuthGuardService implements CanActivate, CanActivateChild {

  constructor(
    private router: Router,
    public nav: NavigationItem,
    private securityService: SecurityService,
  ) { }

  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot) {

    return this.checkAccess(route, state);
  }

  canActivateChild(route: ActivatedRouteSnapshot, state: RouterStateSnapshot) {

    return this.checkAccess(route, state);
  }

  private async checkAccess(route: ActivatedRouteSnapshot, state: RouterStateSnapshot) {

    // 1. Check if user is logged in
    if (SecurityHelper.GetLoggedInUserDto()) {

      if (SecurityHelper.IsHTTPRequestsUnathorized(true)) {
        return false;
      }
      else {

        // Populate navigation items if not yet loaded
        if (this.nav.navigationItems.length == 0) {
          this.nav.navigationItems = await firstValueFrom(this.securityService.getNavigationItems()) as any[];

        }

        // 2. Check if user has access to the page
        if (this.nav.hasPageAccess(state.url)) {
          return true;
        }
        else {

          swal.fire({
            title: "Access Denied",
            html: '<span>The page you are trying to access is not accessible on your account.</span>',
            icon: "error",
            showCloseButton: true,
            allowOutsideClick: false,
            allowEscapeKey: false
          }).then(() => {
            this.router.navigate(['/admin/home']);
          });

          return false;

        }
      }
    }
    else {

      SecurityHelper.GoBackToLoginPage();

      return false;
    }

  }

}

